import Colors from '../../../styles/colors';

const styles = () => ({
    backLink: {
        paddingBottom: 30,

        '& a': {
            color: Colors.persianBlue,
            fontSize: '0.875rem',
            fontWeight: 'bold',
            textDecoration: 'none',
        },

        '& a:hover': {
            textDecoration: 'underline',
        },
    },
    icon: {
        paddingBottom: 20,
        marginLeft: 80,

        '& img': {
            width: 140,
            height: 120,
        },
    },
    description: {
        paddingTop: 10,
    },
    note: {
        width: 220,
        marginLeft: 80,

        '& p': {
            fontSize: '0.875rem',
        },
    },
});

export default styles;
